var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "components-printer" }, [
    _c(
      "div",
      { attrs: { id: "printerContent" } },
      [
        _vm._t("default", function () {
          return [_c("p", [_vm._v("no point content!")])]
        }),
      ],
      2
    ),
    _c("iframe", {
      staticClass: "printer-iframe",
      attrs: {
        src: _vm.printSrc,
        srcdoc: _vm.printerContent,
        id: "printerIframe",
        frameborder: "0",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }